import { ReactElement } from 'react'
import getMFEConfig from 'helpers/getMFEConfig'
import {
  cardStatusTrackerModalContainerId,
  replaceYourCardModalContainerId
} from 'const/modalContainerId'
import useProfileNavigate from 'hooks/useProfileNavigate'
import ReplacementLostStolenMFE from 'replacement-card-mfe'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import { useAtom, useAtomValue } from 'jotai'
import featureFlags from 'const/featureFlags'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import routes from 'const/routes'
import {
  AuthenticationRedirectProps,
  handleMFEAuthenticationRedirect
} from 'helpers/authenticationRedirect'

const ReplaceYourCardModal = (): ReactElement => {
  const [{ modalId }, updateModalStatus] = useAtom(modalStatusAtom)
  const { isCardStatusTrackerEnabled } = featureFlags
  const selectedAccount = useAtomValue(selectedAccountAtom)
  const cardStatusTrackerButtonId =
    cardStatusTrackerModalContainerId(selectedAccount)

  const replacementCardConfig = getMFEConfig('disputes')
  const { handleProfileClick } = useProfileNavigate()

  const handleCloseModal = () => {
    updateModalStatus('', '')
    triggerAnalyticsEvent({
      pageFunction: 'account services',
      pageKind: 'account services'
    })
  }

  const handleTrackYourCardClick = () => {
    handleCloseModal()
    if (isCardStatusTrackerEnabled) {
      updateModalStatus('CardStatusTracker', cardStatusTrackerButtonId)
    }
  }

  const handleAuthFlow = () => {
    const props: AuthenticationRedirectProps = {
      navigateTo: routes.ACCOUNT_SERVICES,
      modal: 'ReplaceYourCard',
      scope: 'read write write:sensitive profile:read:sensitive'
    }

    handleMFEAuthenticationRedirect(props)
  }

  return modalId === 'ReplaceYourCard' ? (
    <ReplacementLostStolenMFE
      config={replacementCardConfig}
      accountId={selectedAccount}
      portalId={replaceYourCardModalContainerId(selectedAccount)}
      isOpen={modalId === 'ReplaceYourCard'}
      onClose={handleCloseModal}
      flow="replacement"
      authenticationRedirect={handleAuthFlow}
      handleProfileClick={handleProfileClick}
      navigationHandler={handleTrackYourCardClick}
      triggerAnalyticsEvent={triggerAnalyticsEvent}
    />
  ) : null
}

export default ReplaceYourCardModal
